/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

export const ContentType = {
    Bin: "application/octet-stream",
    Css: "text/css",
    Glb: "model/gltf-binary",
    FormUrlEncoded: "application/x-www-form-urlencoded",
    Html: "text/html",
    Http: "application/http",
    Jpg: "image/jpeg",
    Js: "application/javascript",
    Json: "application/json",
    MultipartMixed: "multipart/mixed",
    Pdf: "application/pdf",
    Png: "image/png",
    Text: "text/plain",
    Xml: "application/xml",
    Zip: "application/zip",
    Xls: "application/vnd.ms-excel",
    Xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    Doc: "application/msword",
    Docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    Ppt: "application/vnd.ms-powerpoint",
    Pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    Rvt: "application/octet-stream"
};
